import { gql } from "@apollo/client";

export const GET_PARTICIPANT_OUTREACH = gql`
  query GetParticipantOutreach($odrnumber: Int!) {
    getParticipantByODRNumber(odrnumber: $odrnumber) {
      id
      outreach {
        id
        contactMethod
        contactDate
        results
        qaStaff
        address
        city
        zip
        email
        phoneNumber
        nameOfContact
        notes
      }
    }
  }
`;

export const CREATE_PARTICIPANT_OUTREACH = gql`
  mutation CreateParticipantOutreach(
    $odrnumber: Int!
    $participant: Int!
    $input: OutReachInput!
  ) {
    createParticipantOutreach(
      odrnumber: $odrnumber
      participant: $participant
      input: $input
    ) {
      message
    }
  }
`;

export const DELETE_PARTICIPANT_OUTREACH = gql`
  mutation DeleteParticipantOutreach($outreachid: Int!) {
    deleteParticipantOutreach(outreachid: $outreachid) {
      message
    }
  }
`;
